import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { progresso, visivel } from '@/store/preloader'

export default /*@__PURE__*/_defineComponent({
  __name: 'RoutePreloader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["route-preloader-track", { visivel: _unref(visivel) }])
  }, [
    _createElementVNode("div", {
      class: "route-preloader-bar",
      style: _normalizeStyle({ width: `${_unref(progresso)}%` })
    }, null, 4)
  ], 2))
}
}

})